import actionType from "./actionTypes";
import initialState from "./initialState";



const facilityReducer = (state = initialState, action) => {
  switch (action.type) {

      case actionType.FACILITY_CREATE_UPDATE_SELECTED_SUCCESS:
      return {
        ...state,
        facilitySubmitTypesStatus : true,
        facilitySubmitTypesDetails : action.payload,
      };
      case actionType.FACILITY_CREATE_UPDATE_SELECTED_FAILURE:
      return {
        ...state,
        facilitySubmitTypesStatus: false,
      };


      case actionType.FACILITY_SELECT_TYPE_SUCCESS:
      return {
        ...state,
        facilitySelectTypesStatus : true,
        facilitySelectTypesDetails : action.payload,
      };
      case actionType.FACILITY_SELECT_TYPE_FAILURE:
      return {
        ...state,
        facilitySelectTypesDetails:{facilityClassificationList:[]},
        facilitySelectTypesStatus: false,
      };


      case actionType.EMAIL_BAA_DOC_SUCCESS:
      return {
        ...state,
        sendBaaDocStatus : true,
        message : action.message
      };
      case actionType.EMAIL_BAA_DOC_FAILURE:
      return {
        ...state,
        sendBaaDocStatus: false,
        message : action.error
      };

      case actionType.DELETE_PRACTITIONER_SUCCESS:
      return {
        ...state,
        deletePractitionerStatus : true
      };
      case actionType.DELETE_PRACTITIONER_FAILURE:
      return {
        ...state,
        deletePractitionerStatus: false
      };
      case actionType.EDIT_PRACTITIONER_SUCCESS:
      return {
        ...state,
        editPractitionerSuccess : true
      };
      case actionType.EDIT_PRACTITIONER_FAILURE:
      return {
        ...state,
        editPractitionerSuccess: false
      };
      case actionType.GET_PRACTITIONERS_SUCCESS:
      return {
        ...state,
        getPractitionersDetails : action.payload,
        addPractitionersStatus:false,
        getPractitionersStatus: true,
      };
      case actionType.GET_PRACTITIONERS_FAILURE:
      return {
        ...state,
        getPractitionersDetails:{practionerList:[]},
        addPractitionersStatus:false,
        getPractitionersStatus: false,
      };
      case actionType.ADD_PRACTITIONERS_SUCCESS:
      return {
        ...state,
        addPractitionersStatus:true
      };
      case actionType.ADD_PRACTITIONERS_FAILURE:
      return {
        ...state,
        addPractitionersStatus:false
      };
      case actionType.SAVE_REMOTE_VPN_SUCCESS:
      return {
        ...state,
        addRemoteVpnStatus:true
      };
      case actionType.SAVE_REMOTE_VPN_FAILURE:
      return {
        ...state,

        addRemoteVpnStatus:false
      };
      case actionType.GET_REMOTE_ACCESS_VPN_SUCCESS:
      return {
        ...state,
        remoteAccessVpnDetails : action.payload,
        remoteAccessVpnStatus:true
      };
      case actionType.GET_REMOTE_ACCESS_VPN_FAILURE:
      return {
        ...state,
        remoteAccessVpnDetails:{listVpnConnection:[]},
      //  emrOrVpnDetails:{listEmrConnection:[]},
        remoteAccessVpnStatus:false
      };
      case actionType.SAVE_CLOUD_BASE_EMR_SUCCESS:
      return {
        ...state,
        addCloudBaseEmrStatus:true
      };
      case actionType.SAVE_CLOUD_BASE_EMR_FAILURE:
      return {
        ...state,
        addCloudBaseEmrStatus:false
      };
      case actionType.GET_CLOUD_BASE_EMR_VPN_SUCCESS:
      return {
        ...state,
        emrOrVpnDetails: action.payload,
        cloudBaseEmrStatus:true
      };
      case actionType.GET_CLOUD_BASE_EMR_VPN_FAILURE:
      return {
        ...state,
        emrOrVpnDetails:{listEmrConnection:[]},
       // remoteAccessVpnDetails:{listVpnConnection:[]},
        cloudBaseEmrStatus:false
      };
      case actionType.FACILITY_CONFIRM_OTP_SUCCESS:
      return {
        ...state,
        confirmOtpStatus:true
      };
      case actionType.FACILITY_CONFIRM_OTP_FAILURE:
      return {
        ...state,
        confirmOtpStatus:false
      };
      case actionType.FACILITY_SEND_OTP_SUCCESS:
      return {
       ...state,
        sendOtpStatus : true
      };
      case actionType.FACILITY_SEND_OTP_FAILURE:
      return {
        ...state,
         sendOtpStatus : false
      };

      
      case actionType.STATUS_CHANGE_FINAL_REG:
      return{
        ...state,
        sendBaaDocStatus:false,
        confirmOtpStatus:false,
        sendOtpStatus:false,
        facilityRegisterStatus:false

      }
      
      case actionType.SAVE_REG_DATA_STATUS_CHANGE:
      return{
        ...state,
        saveRegDataStatus:false,
      }
      case actionType.SAVE_REG_DATA:
        return{
          ...state,
          saveRegDataStatus:true,
          saveRegisteredData : action.payload
        }
      case actionType.FACILITY_REGISTER_SUCCESS:
      return {
        ...state,
         facilityRegisterStatus: true,
        message: action.message
       };
       case actionType.FACILITY_REGISTER_FAILURE:
       return {
         ...state,
         message: action.message,
         facilityRegisterStatus: false
       };
       case actionType.FACILITY_REQ_LIST_SUCCESS:
       return{
         ...state,
         facilityReqInfoStatus: true,
         facilityReqInfoList: action.payload
       }
       case actionType.VERIFY_SERVICE_SUCCESS:
       return {
         ...state,
         verifyServiceDetails:action.payload,
         verifyServiceStatus: true
       };
       case actionType.VERIFY_SERVICE_FAILURE:
       return {
         ...state,
         message: action.message,
         verifyServiceStatus: false
       };
       case actionType.APPROVE_FACILITY_SUCCESS:
       return {
         ...state,
        
         approveStatus: true
       };
       case actionType.APPROVE_FACILITY_FAILURE:
       return {
         ...state,
         message: action.message,
         approveStatus: false
       };
       case actionType.DECLINE_FACILITY_SUCCESS:
       return {
         ...state,
        
         declineStatus: true
       };
       case actionType.DECLINE_FACILITY_FAILURE:
       return {
         ...state,
         message: action.message,
         declineStatus: false
       };

    default:
      return state;
  }
};
 export default facilityReducer;